const objectize = (arr, field = 'url') => {
  return (arr || []).reduce((obj, el) => ({ ...obj, [el[field]]: el }), {});
};

export default objectize;
